export const environment = {
	production: false,
	lsKey: 'tZJaq72y3buBxQAPTPv4',
	serverBasePath: 'https://dental-360-int-dev.hasura.app',
	//serverPath: "https://dental-360.herokuapp.com",
	serverPath: "https://api.dentalinterface.com",

	x_hasura_admin_secret: 'ZfEL0n3LsZMGB0oRJCdToQQhMhALea6s0i2VwzhvW76XuDxuwGc9A25kRLDghYwO',
	hasuraInternalUrl: "https://dental-360-dev.hasura.app/v1/graphql",
	hasuraExternalHttpUrl: "https://dental-360-dev.hasura.app/v1/graphql",
	hasuraExternalWssUrl: "wss://dental-360-dev.hasura.app/v1/graphql",
	siteUrl: "http://localhost:4200",
	otherId: "666d85af-62a7-4c50-9dba-c30f7c589b4d",
	frontendPath: "https://di360-ba1d7.web.app",
};
